/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSupportingExaminationDictDto
 */
export interface CreateUpdateSupportingExaminationDictDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDictDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSupportingExaminationDictDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDictDto
     */
    type?: CreateUpdateSupportingExaminationDictDtoTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateSupportingExaminationDictDto
     */
    systemNumber?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDictDto
     */
    synevoCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDictDto
     */
    testId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateSupportingExaminationDictDto
     */
    alternativeTests?: Array<string> | null;
}


/**
 * @export
 */
export const CreateUpdateSupportingExaminationDictDtoTypeEnum = {
    helpExam: 'helpExam',
    specialisedConsultation: 'specialisedConsultation'
} as const;
export type CreateUpdateSupportingExaminationDictDtoTypeEnum = typeof CreateUpdateSupportingExaminationDictDtoTypeEnum[keyof typeof CreateUpdateSupportingExaminationDictDtoTypeEnum];


/**
 * Check if a given object implements the CreateUpdateSupportingExaminationDictDto interface.
 */
export function instanceOfCreateUpdateSupportingExaminationDictDto(value: object): value is CreateUpdateSupportingExaminationDictDto {
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('synevoCode' in value) || value['synevoCode'] === undefined) return false;
    if (!('testId' in value) || value['testId'] === undefined) return false;
    return true;
}

export function CreateUpdateSupportingExaminationDictDtoFromJSON(json: any): CreateUpdateSupportingExaminationDictDto {
    return CreateUpdateSupportingExaminationDictDtoFromJSONTyped(json, false);
}

export function CreateUpdateSupportingExaminationDictDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSupportingExaminationDictDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'],
        'type': json['type'] == null ? undefined : json['type'],
        'systemNumber': json['systemNumber'] == null ? undefined : json['systemNumber'],
        'synevoCode': json['synevoCode'],
        'testId': json['testId'],
        'alternativeTests': json['alternativeTests'] == null ? undefined : json['alternativeTests'],
    };
}

export function CreateUpdateSupportingExaminationDictDtoToJSON(value?: CreateUpdateSupportingExaminationDictDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'active': value['active'],
        'type': value['type'],
        'systemNumber': value['systemNumber'],
        'synevoCode': value['synevoCode'],
        'testId': value['testId'],
        'alternativeTests': value['alternativeTests'],
    };
}

